import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-common-snackbar',
  templateUrl: './common-snackbar.component.html',
  styleUrls: ['./common-snackbar.component.scss'],
})
export class CommonSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackBarRef: MatSnackBarRef<CommonSnackbarComponent>,
    private router: Router
  ) {}

  handlePrimary() {
    if (this.data.redirectUrl) {
      this.router.navigate(this.data.redirectUrl.path, {
        queryParams: this.data.redirectUrl.queryParams,
      });
    }

    if (this.data.primaryCallback) {
      this.data.primaryCallback();
    }

    this.snackBarRef.dismiss();
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
